var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mortgage-page'),_vm._v(" "),_c('stacked-modal-root',{attrs:{"id":"stacked-modal-root"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }